// extracted by mini-css-extract-plugin
module.exports = {"icon":"shopping-bag_icon__nHQr7"};